export default "__VITE_ASSET__DcaMolxs__"